module.exports = __webpack_public_path__ + "static/media/seatbeltsafedrive new.f5326852.jpg";